import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import "./i18n/config"; // Import i18n configuration

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(<App />);